// The Training vertical is served by the standalone training-webapp (nginx
// routes /training/* on the org subdomains to its dev server on :3005).
// flex2-webapp does not mount trainingRoutes; instead this catch-all turns
// any SPA navigation into /training/* (system picker, sidebar links, login
// default-route) into a full page load so the browser actually leaves this
// bundle and fetches training-webapp's index.
//
// Without this, every in-app link to /training/* falls through to the
// catch-all and lands on /login.
//
// Loop guard: on hosts whose nginx does NOT route /training to
// training-webapp (e.g. personal dev instances), the reload lands straight
// back here — detect the immediate re-entry and show a note instead of
// reloading forever.
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const LAST_HANDOFF_KEY = "trainingHandoffAt";

export default function TrainingHandoff() {
  const { pathname, search } = useLocation();
  const [looping, setLooping] = useState(false);

  useEffect(() => {
    const last = Number(sessionStorage.getItem(LAST_HANDOFF_KEY) || 0);
    if (Date.now() - last < 5000) {
      setLooping(true);
      return;
    }
    sessionStorage.setItem(LAST_HANDOFF_KEY, String(Date.now()));
    window.location.replace(pathname + search);
  }, [pathname, search]);

  if (!looping) return null;
  return (
    <div style={{ padding: 40, fontFamily: "sans-serif" }}>
      The Training portal is served by training-webapp, but this host&apos;s
      nginx isn&apos;t routing <code>/training</code> to it — see
      /etc/nginx/sites-enabled/liftconnectpro.dev for the reference block.
    </div>
  );
}
